import styled from "styled-components"
import {bodyText} from "@irati/ui/src/global/css/text"
import {minWidthMedia} from "@irati/ui/src/global/media"


export default styled.div`
  ${bodyText}
  position: relative;
  padding-top: 1px;
  height: 25px;

  > * {
    vertical-align: middle;
  }

  ${minWidthMedia.tablet`

  `}
`
